// import ToggleContent from "../helpers/ToggleContent";

class Header {
  constructor() {
    this.config = {
      open: document.querySelector(".js-navbar-open"),
      close: document.querySelector(".js-navbar-close"),
      menu: document.querySelector("#NavDrawer"),
      document: document.querySelectorAll("html, body"),

      searchBar: document.querySelector(".navbar-search"),
      searchBarOpen: document.querySelector(".js-search-open"),
      searchBarClose: document.querySelector(".js-search-close"),

      mainNavigation: document.querySelector(".v-main-header"),
      body: document.querySelector("body"),
      // dropdowns: this.config.menu.querySelectorAll('[data-toggle-dropdown]')
    };

    // this.open()
  }

  init() {
    this.config.open.addEventListener("click", this.open.bind(this));
    this.config.close.addEventListener("click", this.close.bind(this));

    console.log("[Techyon] Init Header");
    if (this.config.body.classList.contains("template-index")) {
      this.headerScrollListener();
    }
  }

  open() {
    this.config.document[0].classList.add("js-drawer-opened");
    this.config.document[1].classList.add("js-drawer-opened");
    this.config.menu.classList.add("is-open");
  }

  close() {
    this.config.document[0].classList.remove("js-drawer-opened");
    this.config.document[1].classList.remove("js-drawer-opened");
    this.config.menu.classList.remove("is-open");
  }

  openSearch(event) {
    event.preventDefault();
    this.config.searchBar.classList.add("is-open");
    this.config.searchBar.querySelector(".input").focus();
  }

  closeSearch(event) {
    event.preventDefault();
    this.config.searchBar.classList.remove("is-open");
  }

  headerScrollListener() {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 0) {
        console.log("[Techyon] scroll > 0");
        this.config.mainNavigation.classList.remove("is-inversed");
        this.config.mainNavigation.classList.add("with-transitions");
      } else {
        if (
          !this.config.mainNavigation.classList.contains("has-dropdown-opened")
        ) {
          this.config.mainNavigation.classList.add("is-inversed");
        }
      }
    });
  }
}

export default new Header();
